import React from "react";
import icon1 from "../img/CardIcones/icon1.svg";
import icon2 from "../img/CardIcones/icon2.svg";
import icon3 from "../img/CardIcones/icon3.svg";
import icon4 from "../img/CardIcones/icon4.svg";
import { getFileServer, getUrlApi, hideProcess, showProcess } from "../utils/util";
import { Galleria } from "primereact/galleria";
import bannersService from "../services/bannersService";

export default class BhnInentivos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productsHighlight: [],
            windowWidth: window.innerWidth,
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();
            const responseBanners = await bannersService.getBanners();

            this.urlApi = await getUrlApi();

            if (responseBanners.status === 200) {
                this.setState({
                    banners: responseBanners.data.sort((a, b) => a.index - b.index)
                });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data);
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();

    }

    render() {
        const { windowWidth } = this.state;
        const isMobile = windowWidth <= 768;
        const beneficios = [
            {
                id: 1,
                title: "Reconhecer os melhores desempenhos",
                icon: icon1,
            },
            {
                id: 2,
                title: "Comemore o atingimento de metas e objetivos",
                icon: icon2,
            },
            {
                id: 3,
                title: "Incentive treinamentos, pesquisas e programas de bem-estar",
                icon: icon3,
            },
            {
                id: 4,
                title: "Incentive treinamentos, pesquisas e programas de bem-estar",
                icon: icon4,
            },
        ];
        return (
            <>
                {/* BANNER PRINCIPAL */}
                <Galleria
                    transitionInterval={5000}
                    value={this.state.banners}
                    autoPlay
                    circular
                    item={(item) => (
                        <img
                            src={`${this.urlApi}/resources/banners/${item.id}.banner`}
                            onClick={() => window.location.href = item.command}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                borderRadius: "10px",
                                maxHeight: "600px",
                                cursor: item.command ? "pointer" : "default"
                            }}
                            alt="banner"
                        />
                    )}
                    showThumbnails={false}
                    showIndicators
                    style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "100%",
                    }}
                />

                {/* Conteúdo secundário */}
                <div
                    style={{
                        padding: "50px 20px",
                        textAlign: "center",
                    }}
                >
                    <h2
                        style={{
                            color: "#411172",
                            fontSize: window.innerWidth < 768 ? "22px" : "42px",
                            fontWeight: "bold",
                            marginBottom: "10px",
                        }}
                    >
                        As melhores vantagens para sua empresa
                    </h2>

                    <p
                        style={{
                            fontSize: window.innerWidth < 768 ? "14px" : "22px",
                            color: "#333",
                            maxWidth: "900px",
                            margin: "0 auto",
                            color: "#411172",
                            fontWeight: "600",
                        }}
                    >
                        Soluções perfeitas para campanhas de incentivo, premiações, ações de vendas
                        e reconhecimento interno.
                    </p>
                </div>

                <div
                    style={{
                        width: "100%",
                        padding: "20px 10px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "15px",
                        boxSizing: "border-box",
                    }}
                >
                    {beneficios.map((item) => (
                        <div
                            key={item.id}
                            style={{
                                backgroundColor: "#fff",
                                border: "1px solid #eee",
                                borderRadius: "15px",
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                                width: window.innerWidth < 768 ? "100%" : "23%",
                                minWidth: "150px",
                                textAlign: "center",
                                padding: "20px 10px",
                            }}
                        >
                            <img
                                src={item.icon}
                                alt={item.title}
                                style={{
                                    width: "120px",
                                    height: "120px",
                                    marginBottom: "12px",
                                }}
                            />

                            <span
                                style={{
                                    color: "#411172",
                                    fontSize: window.innerWidth < 768 ? "12px" : "14px",
                                    fontWeight: "600",
                                    display: "block",
                                    minHeight: "50px",
                                    lineHeight: "1.3",
                                }}
                            >
                                {item.title}
                            </span>
                        </div>
                    ))}
                </div>

                <span
                    className="unnamed-character-style-5"
                    style={{
                        display: "block",
                        textAlign: "center",
                        fontSize: isMobile ? "1.4em" : "1.8em",
                        fontWeight: "bold",
                        marginTop: isMobile ? "15px" : "20px",
                        color: "#110235",
                    }}
                >
                    Mais comprados
                </span>

                <section
                    className="app-cards-container"
                    style={{
                        marginTop: isMobile ? "15px" : "25px",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        overflowX: "hidden", // impede scroll lateral
                        overflowY: "hidden", // evita scroll vertical no hover
                        boxSizing: "border-box",
                    }}
                >
                    <div
                        className="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: isMobile ? "12px" : "25px",
                            width: isMobile ? "95%" : "80%",
                            maxWidth: "1200px",
                            boxSizing: "border-box",
                            overflow: "hidden",
                        }}
                    >
                        {this.state.productsHighlight.map((p, i) => (
                            <div
                                key={i}
                                className="app-card-product"
                                onClick={() => (window.location.href = "/product/" + p.id)}
                                style={{
                                    width: isMobile ? "45%" : "200px",
                                    minWidth: isMobile ? "140px" : "200px",
                                    border: "1px solid #eee",
                                    borderRadius: "10px",
                                    padding: isMobile ? "8px" : "10px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    backgroundColor: "#fff",
                                    transformOrigin: "center center", // evita empurrar layout
                                    willChange: "transform",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.03)";
                                    e.currentTarget.style.zIndex = 10; // faz o card “sobrepor” os outros sem empurrar
                                    e.currentTarget.style.boxShadow =
                                        "0px 6px 14px rgba(0,0,0,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.zIndex = 1;
                                    e.currentTarget.style.boxShadow = "0px 2px 8px rgba(0,0,0,0.1)";
                                }}
                            >
                                <img
                                    src={`${this.state.fileServer}/cards/${p.id}.png`}
                                    alt={p.displayName}
                                    style={{
                                        width: "100%",
                                        height: isMobile ? "120px" : "160px",
                                        objectFit: "contain",
                                        marginBottom: "10px",
                                    }}
                                />
                                <span
                                    className="app-card-product-name"
                                    style={{
                                        display: "block",
                                        fontWeight: "bold",
                                        fontSize: isMobile ? "0.9em" : "1em",
                                        marginBottom: "5px",
                                        color: "#333",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {p.displayName}
                                </span>
                                <p
                                    className="app-card-product-price"
                                    style={{
                                        color: "#007bff",
                                        marginBottom: "10px",
                                        fontSize: isMobile ? "0.85em" : "1em",
                                    }}
                                >
                                    {this.listPrices(p)}
                                </p>
                                <button
                                    style={{
                                        background:
                                            "linear-gradient(90deg, #007BFF 0%, #0056D2 100%)",
                                        color: "#fff",
                                        border: "none",
                                        padding: isMobile ? "6px 10px" : "8px 14px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: isMobile ? "0.85em" : "1em",
                                        width: "100%",
                                    }}
                                >
                                    Comprar
                                </button>
                            </div>
                        ))}
                    </div>
                </section>

                <span
                    className="unnamed-character-style-5"
                    style={{
                        display: "block",
                        textAlign: "center",
                        fontSize: isMobile ? "1.4em" : "1.8em",
                        fontWeight: "bold",
                        marginTop: isMobile ? "15px" : "20px",
                        color: "#110235",
                    }}
                >
                    Destaques
                </span>

                <section
                    className="app-cards-container"
                    style={{
                        marginTop: isMobile ? "15px" : "25px",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        overflowX: "hidden", // impede scroll lateral
                        overflowY: "hidden", // evita scroll vertical no hover
                        boxSizing: "border-box",
                    }}
                >
                    <div
                        className="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: isMobile ? "12px" : "25px",
                            width: isMobile ? "95%" : "80%",
                            maxWidth: "1200px",
                            boxSizing: "border-box",
                            overflow: "hidden",
                        }}
                    >
                        {this.state.productsHighlight.map((p, i) => (
                            <div
                                key={i}
                                className="app-card-product"
                                onClick={() => (window.location.href = "/product/" + p.id)}
                                style={{
                                    width: isMobile ? "45%" : "200px",
                                    minWidth: isMobile ? "140px" : "200px",
                                    border: "1px solid #eee",
                                    borderRadius: "10px",
                                    padding: isMobile ? "8px" : "10px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    backgroundColor: "#fff",
                                    transformOrigin: "center center", // evita empurrar layout
                                    willChange: "transform",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.03)";
                                    e.currentTarget.style.zIndex = 10; // faz o card “sobrepor” os outros sem empurrar
                                    e.currentTarget.style.boxShadow =
                                        "0px 6px 14px rgba(0,0,0,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.zIndex = 1;
                                    e.currentTarget.style.boxShadow = "0px 2px 8px rgba(0,0,0,0.1)";
                                }}
                            >
                                <img
                                    src={`${this.state.fileServer}/cards/${p.id}.png`}
                                    alt={p.displayName}
                                    style={{
                                        width: "100%",
                                        height: isMobile ? "120px" : "160px",
                                        objectFit: "contain",
                                        marginBottom: "10px",
                                    }}
                                />
                                <span
                                    className="app-card-product-name"
                                    style={{
                                        display: "block",
                                        fontWeight: "bold",
                                        fontSize: isMobile ? "0.9em" : "1em",
                                        marginBottom: "5px",
                                        color: "#333",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {p.displayName}
                                </span>
                                <p
                                    className="app-card-product-price"
                                    style={{
                                        color: "#007bff",
                                        marginBottom: "10px",
                                        fontSize: isMobile ? "0.85em" : "1em",
                                    }}
                                >
                                    {this.listPrices(p)}
                                </p>
                                <button
                                    style={{
                                        background:
                                            "linear-gradient(90deg, #007BFF 0%, #0056D2 100%)",
                                        color: "#fff",
                                        border: "none",
                                        padding: isMobile ? "6px 10px" : "8px 14px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: isMobile ? "0.85em" : "1em",
                                        width: "100%",
                                    }}
                                >
                                    Comprar
                                </button>
                            </div>
                        ))}
                    </div>
                </section>

                <div
                    style={{
                        padding: "50px 20px",
                        textAlign: "center",
                    }}
                >
                    <h2
                        style={{
                            color: "#411172",
                            fontSize: window.innerWidth < 768 ? "22px" : "42px",
                            fontWeight: "bold",
                            marginBottom: "10px",
                        }}
                    >
                        Precisa comprar em maiores quantidades
                        <br /> ou cartões-presente de outras marcas?
                    </h2>

                    <p
                        style={{
                            fontSize: window.innerWidth < 768 ? "14px" : "22px",
                            color: "#411172",
                            maxWidth: "900px",
                            margin: "0 auto",
                            fontWeight: "600",
                        }}
                    >
                        Você passa qual a sua neessidade e nós resolvemos todo o resto.
                        <br />
                        Fale com um dos nossos especialistas!
                    </p>

                    <a
                        target="_blank"
                        href="https://wa.me/5511942505855?text=Ol%C3%A1%2C%20gostaria%20de%20%20saber%20mais%20sobre%20a%20BHN"
                        style={{ textDecoration: "none" }}
                    >
                        <button
                            style={{
                                marginTop: window.innerWidth < 768 ? "20px" : "28px",
                                backgroundColor: "#fff",
                                color: "#411172",
                                cursor: "pointer",
                                fontSize: window.innerWidth < 768 ? "13px" : "16px",
                                border: "solid 2px #411172",
                                fontWeight: "700",
                                padding: window.innerWidth < 768 ? "8px 16px" : "12px 26px",
                                borderRadius: "30px",
                                transition: "all 0.25s ease-in-out",
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = "scale(1.07)";
                                e.target.style.backgroundColor = "#411172";
                                e.target.style.color = "#FFF";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "scale(1)";
                                e.target.style.backgroundColor = "#FFF";
                                e.target.style.color = "#411172";
                            }}
                        >
                            Entrar em contato
                        </button>
                    </a>
                </div>

                {/* Bloco Benefícios - Rede de Parceiros */}
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: window.innerWidth < 900 ? "column" : "row",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "50px 30px",
                        boxSizing: "border-box",
                    }}
                >
                    {/* Imagem grande */}
                    <div style={{ flex: 1 }}>
                        <img
                            src={require("../img/Banner003.png")}
                            alt="Colaboradores felizes"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "10px",
                            }}
                        />
                    </div>

                    {/* Logos */}
                    <div
                        style={{
                            flex: 1,
                            display: "grid",
                            gridTemplateColumns:
                                window.innerWidth < 600 ? "1fr 1fr" : "repeat(3, 1fr)",
                            gap: "18px",
                            padding: window.innerWidth < 900 ? "30px 0" : "0 30px",
                            justifyItems: "center",
                        }}
                    >
                        {[
                            "uber",
                            "razer-gold",
                            "spotify",
                            "roblox",
                            "mcdonalds",
                            "decathlon",
                            "airbnb",
                            "bobs",
                            "rihappy",
                            "zattini",
                            "nintendo",
                            "zedelivery",
                        ].map((logo) => (
                            <div
                                key={logo}
                                style={{
                                    width: "100%",
                                    maxWidth: "160px",
                                    height: "88px",
                                    borderRadius: "12px",
                                    backgroundColor: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                }}
                            >
                                <img
                                    src={require(`../img/marcas/${logo}.avif`)}
                                    alt={logo}
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "60px",
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div
                    style={{
                        padding: "50px 20px",
                        textAlign: "center",
                    }}
                >
                    <h2
                        style={{
                            color: "#411172",
                            fontSize: window.innerWidth < 768 ? "22px" : "42px",
                            fontWeight: "bold",
                            marginBottom: "10px",
                        }}
                    >
                        Nosso portfolio é diversificado
                        <br /> e completo para surpreender sempre
                    </h2>

                    <p
                        style={{
                            fontSize: window.innerWidth < 768 ? "14px" : "22px",
                            color: "#411172",
                            maxWidth: "900px",
                            margin: "0 auto",
                            fontWeight: "600",
                        }}
                    >
                        Os cartões-presente são assertivos, use isso a favor das suas campanhas.
                    </p>
                </div>

                {/* Se for necessário, descomentar este trecho */}
                {/* <p
  style={{
    width: "100%",
    textAlign: "right",
    fontSize: "12px",
    paddingRight: "30px"
  }}
>
  *Nas versões física ou digital.
</p> */}
            </>
        );
    }
}
